export default async function useMapCenter() {
  const { currentCenter } = await useCurrentCenter()

  if (!currentCenter.value?.latitude || !currentCenter.value?.longitude) {
    console.error('No latitude or longitude found for current center, falling back to center of Netherlands')
    return [52.132633, 5.291266]
  }

  console.log('currentCenter', currentCenter.value)

  if (currentCenter.value?.latitude && currentCenter.value?.longitude) {
    return [currentCenter.value?.latitude, currentCenter.value?.longitude]
  }

  // Else center NL.
  return [52.1326, 5.2913]
}
